import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../helpers/actions';
import Led from './components/Desk/Led';
import { colors } from './WindowConfig';

export interface ILedSwitchProps {
  children?: any;
  showLed?: boolean;
  id?: string;
}

const Container = styled.div<any>`
  width: 66px;
  height: 56px;
  border: solid 3px
    ${(props) => (props.on ? colors.ledSwitchOnColor : colors.white)};
  color: ${(props) => (props.on ? colors.ledSwitchOnColor : colors.white)};
  margin: 0px 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
`;

const BorderedLed = styled(Led)`
  > div {
    border: 5px solid black;
  }
  margin-top: 10px;
`;

export default function LedSwitch(props: ILedSwitchProps) {
  const { children, showLed, id = '' } = props;
  const dispatch = useDispatch();
  const lowerMonitorButtons = useSelector(
    (state: any) => state.executor.s80.lowerMonitorButtons
  );
  const lowerMonitorLEDs = useSelector(
    (state: any) => state.executor.s80.lowerMonitorLEDs
  );
  const isOn = lowerMonitorButtons[id];
  const isLedOn = lowerMonitorLEDs[id];
  const handleClick = () => {
    dispatch(
      ComposedActions.PressGeneralButtonSwitch.aCreator({
        id,
        isActive: !isOn,
      })
    );
  };
  return (
    <React.Fragment>
      {showLed && (
        <BorderedLed
          ledOn={isLedOn}
          circular
          offColor={colors.monitorLedOffColor}
          onColor={colors.monitorLedOnColor}
        />
      )}
      <Container on={isOn} onClick={handleClick}>
        <div id={id}>{children}</div>
      </Container>
    </React.Fragment>
  );
}
